import { render, staticRenderFns } from "./NCurrencyInput.vue?vue&type=template&id=5a9df4ba&scoped=true&"
import script from "./NCurrencyInput.vue?vue&type=script&lang=js&"
export * from "./NCurrencyInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9df4ba",
  null
  
)

export default component.exports